<template>

    <div id="recap" class="wrap">
        <!-- NATURE -->
        <div class="p-4 bg-gris-clair rounded-lg shadow mb-4">
            <ul>
                <li v-if="fibsdd.natures.contractuel !== null">
                    <p class="text-md text-primary">Intervention contractuelle : <span
                            class="font-bold text-secondary uppercase">{{ fibsdd.natures.contractuel === true ? 'oui' :
                                'non' }}</span></p>
                </li>
                <li v-if="fibsdd.natures.description">
                    <p class="text-md text-primary">Descriptif demande : <span id="desc-demande"
                            class="font-bold text-secondary">{{ fibsdd.natures.description }}</span></p>
                </li>

                <p class="font-bold mt-2 uppercase">NATURE(S) DE L'INTERVENTION</p>

                <li class="font-bold text-secondary" v-if="fibsdd.natures.assemblage">
                    <p>Assemblage de l'équipement</p>
                </li>
                <li class="font-bold text-secondary" v-if="fibsdd.natures.miseEnService">
                    <p>Mise en service de l'équipement</p>
                </li>
                <li class="font-bold text-secondary" v-if="fibsdd.natures.modification">
                    <p>Modification de l'équipement</p>
                </li>
                <li class="font-bold text-secondary" v-if="fibsdd.natures.maintenance">
                    <p>Maintenance de l'équipement</p>
                </li>
                <li class="font-bold text-secondary" v-if="fibsdd.natures.controlePeriodique">
                    <p>Contrôle d'étanchéité périodique</p>
                </li>
                <li class="font-bold text-secondary" v-if="fibsdd.natures.controleNonPeriodique">
                    <p>Contrôle d'étanchéité non périodique</p>
                </li>
                <li class="font-bold text-secondary" v-if="fibsdd.natures.demantelement">
                    <p>Démantèlement</p>
                </li>
                <li class="font-bold text-secondary" v-if="fibsdd.natures.retrofit">
                    <p>Rétrofit {{ retrait }} => {{ ajout }}</p>
                </li>
                <li class="font-bold text-secondary">
                    <p>{{ fibsdd.natures.autres }}</p>
                </li>
                <li class="font-bold text-secondary">
                    <pre v-if="fibsdd.natures.observations !== '' && fibsdd.natures.observations !== null"
                        id="observ-nature">{{ fibsdd.natures.observations }}</pre>
                </li>
            </ul>
        </div>

        <!-- FUITES -->
        <div class="p-4 bg-gris-clair rounded-lg shadow mb-4"
            v-if="fibsdd.natures.controlePeriodique || fibsdd.natures.controleNonPeriodique">
            <ul class="fuites">
                <p class="font-bold text-secondary" v-if="fibsdd.ctrlEtanch.no_fuites === true">AUCUNE FUITE CONSTATÉE
                </p>

                <div v-else>
                    <p class="font-bold mt-2 uppercase">FUITES(S) CONSTATÉE(S)</p>

                    <li v-for="fuite in fuites" :key="fuite.id">
                        <p class="font-bold text-secondary">Fuite {{ fuite.order }} ({{ fuite.localisation }}) :
                            réparation {{ (fuite.reparation) ? 'réalisée' : 'à faire' }}</p>
                    </li>
                </div>
            </ul>
        </div>

        <!-- MANIP -->
        <div v-if="fibsdd.operations.length > 0" class="p-4 bg-gris-clair rounded-lg shadow mb-4">
            <ul class="manips">
                <p class="font-bold mt-2 uppercase">MANIPULATION(S) DE FLUIDE</p>

                <li v-for="op in fibsdd.operations" :key="op.id">
                    <p class="font-bold text-secondary">{{ op.type }} : {{ op.quantite }}Kg - {{
                        (op.type.indexOf('Retrait') === -1) ? ajout : retrait }}</p>
                </li>
            </ul>
        </div>

        <!-- RESUME -->
        <div class="p-4 bg-gris-clair rounded-lg shadow mb-4">
            <ul>
                <p class="font-bold mt-2 uppercase">INFORMATIONS SUR L'INTERVENTION</p>

                <li v-if="fibsdd.technicien">
                    <p class="text-md text-primary">TECHNICIEN :
                        <span class="font-bold text-secondary" id="resume-user" v-if="fibsdd.technicien.nom">
                            {{ fibsdd.technicien.last_name.toUpperCase() }} {{ fibsdd.technicien.first_name }}
                        </span>
                    </p>
                </li>

                <li v-if="fibsdd.informations.temps_deplacement">
                    <p class="text-md text-primary">DÉPLACEMENT :
                        <span class="font-bold text-secondary" id="resume-duree-dep">
                            {{ fibsdd.informations.temps_deplacement }}</span>
                    </p>
                </li>

                <li v-if="fibsdd.informations.kilometrage">
                    <p class="text-md text-primary">KILOMÉTRAGE :
                        <span class="font-bold text-secondary" id="resume-kilometrage">{{
                            fibsdd.informations.kilometrage }}</span>
                    </p>

                </li>

                <li v-if="fibsdd.informations.temps_intervention">
                    <p class="text-md text-primary">DURÉE DE L'INTERVENTION :
                        <span class="font-bold text-secondary" id="resume-duree-inter">{{
                            fibsdd.informations.temps_intervention }}</span>
                    </p>

                </li>

                <li v-if="fibsdd.informations.heure_arrivee">
                    <p class="text-md text-primary">HEURE D'ARRIVÉE :
                    <p id="resume-heure-arrivee">{{ fibsdd.informations.heure_arrivee }}</span></p>

                </li>

                <li v-if="fibsdd.informations.heure_depart">
                    <p class="text-md text-primary">HEURE DE DÉPART :
                        <span class="font-bold text-secondary" id="resume-heure-depart">{{
                            fibsdd.informations.heure_depart }}</span>
                    </p>

                </li>

                <li v-if="fibsdd.informations.techs">
                    <p class="text-md text-primary">NOMBRE DE TECHNICIENS :
                        <span class="font-bold text-secondary" id="resume-techs">{{ fibsdd.informations.techs }}</span>
                    </p>

                </li>

                <li v-if="fibsdd.informations.namesTechniciens">
                    <p class="text-md text-primary">NOMS DES TECHNICIENS :
                        <span class="font-bold text-secondary" id="resume-names-techs">{{
                            fibsdd.informations.namesTechniciens }}</span>
                    </p>

                </li>

                <div v-if="fibsdd.informations.preventif ||
                    fibsdd.informations.correctif ||
                    fibsdd.informations.fromDevis ||
                    fibsdd.informations.garantie ||
                    fibsdd.informations.finish ||
                    fibsdd.informations.needDevis">
                    <p class="text-md text-primary">TYPE D'INTERVENTION :</p>

                    <li v-if="fibsdd.informations.preventif">
                        <p class="font-bold text-secondary">PREVENTIF (visite d'entretien)</p>
                    </li>
                    <li v-if="fibsdd.informations.correctif">
                        <p>CORRECTIF (dépannage)</p>
                    </li>
                    <li v-if="fibsdd.informations.fromDevis">
                        <p class="font-bold text-secondary">INTERVENTION SELON DEVIS</p>
                    </li>
                    <li v-if="fibsdd.informations.garantie">
                        <p class="font-bold text-secondary">INSTALLATION SOUS GARANTIE</p>
                    </li>
                    <li v-if="fibsdd.informations.finish">
                        <p class="font-bold text-secondary">TRAVAUX TERMINÉS</p>
                    </li>
                    <li v-if="fibsdd.informations.needDevis">
                        <p class="font-bold text-secondary">DEVIS À RÉALISER</p>
                    </li>
                </div>

                <li v-if="fibsdd.informations.travauxEffectues">
                    <p class="text-md text-primary">TRAVAUX EFFECTUÉS :
                        <span class="font-bold text-secondary" id="resume-travaux">{{
                            fibsdd.informations.travauxEffectues }}</span>
                    </p>

                </li>

                <li v-if="fibsdd.informations.observations">
                    <p class="text-md text-primary">OBSERVATIONS :
                        <span class="font-bold text-secondary" id="resume-observ">{{ fibsdd.informations.observations
                        }}</span>
                    </p>
                </li>
            </ul>
        </div>

        <!-- PIECES -->
        <div class="p-4 bg-gris-clair rounded-lg shadow mb-4" v-if="fibsdd.pieces.length > 0">
            <ul class="pieces">
                <p class="text-md text-primary">FOURNITURES</p>
                <li v-for="p in fibsdd.pieces" :key="p.id">
                    <p class="font-bold text-secondary">{{ p.designation | upperCase }} : {{ p.etat }} {{ p.qte }} <span
                            v-if="p.prix">x {{ p.prix
                            }}€</span>
                    </p>
                </li>
            </ul>
        </div>
        <div class=" mb-4">
            <p id="cgv" class="text-sm text-gray-700 italic">
                Le client soussigné reconnait l'exactitude des travaux, fournitures, frais de déplacement, temps
                d'intervention et s'engage à en solder le montant à "{{ operateur }}".
                Clause de réserve de propriété en application de la loi n°80335 du 12.05.80, les marchandises livrées
                restent la propriété du vendeur jusqu'au paiement intégral de leur prix.
                Vous avez pris connaissance de nos C G V et les acceptez.
            </p>
        </div>
    </div>

</template>

<script>
import Installation from '../../../../js/models/Installation'
import Fluide from '../../../../js/models/Fluide'


export default {
    data() {
        return {
            ajout: "",
            retrait: "",
            operateur: ''
        }
    },
    props: {
        fibsdd: {},
        fuites: {
            type: Array,
            default: []
        }
    },
    methods: {
        // TODO : NE FONCTIONNE PAS
        fetchFluides() {
            if (this.fibsdd.installation) {

                Installation
                    .getInstallation(this.fibsdd.installation)
                    .then(install => {

                        if (install.fluide !== null) {
                            this.retrait = install.fluide.nom;

                            if (this.fibsdd.natures.newFluide !== null && this.fibsdd.natures.retrofit === true) {

                                let fluideObj = new Fluide;
                                fluideObj
                                    .getFluide(this.fibsdd.natures.newFluide, fluide => {
                                        this.ajout = fluide.nom
                                    })

                            } else {

                                this.ajout = install.fluide.nom

                            }
                        }

                    })
                    .catch()
            }
        },
        fetchOperatorName() {
            localforage.getItem('profil').then(usr => {
                usr = JSON.parse(usr);
                this.operateur = usr.operator.company
            })
        }
    },
    mounted() {
        this.fetchOperatorName()
    },
    updated() {
        this.fetchFluides()
    },
    filters: {
        upperCase(val) {
            return val.toUpperCase()
        }
    }
}

</script>



// WEBPACK FOOTER //
// Recap.vue?2512e808